<template>
  <section>
    <Navbar />
    <div id="greyBackground">
      <div class="refreshOption">
        <div
          class="refreshButton"
          :class="{
            canRefresh: canUpdate,
          }"
          @click="refreshPage()"
        >
          Refresh
        </div>
      </div>
      <p class="boldTitle leftAligned">Daily User Joined</p>
      <div class="whiteStatBox">
        <div class="analyticsBoldFont">Showing results for</div>
        <div class="analyticsBigFont">
          <!--@click="openJoinedPerUni('joined')"-->
          {{ currentPicked }}
          <img height="20" width="20" src="../assets/analyticsDropown.svg" />
        </div>

        <div v-if="onJoinedUniList" class="uniListBox">
          <div
            v-for="(uniName, index) in listOfUnis"
            :key="index"
            class="uniListOption"
            @click="pickJoinedUni(uniName)"
          >
            {{ uniName }}
          </div>
        </div>

        <div class="graph">
          <div
            class="graphItem"
            v-for="(userCount, index) in userJoinedPerDay"
            :key="index"
          >
            <div
              class="analyticsGraphLine"
              :style="{
                'max-height': `calc(${(userCount / maxUserJoinedPerDay) *
                  100}%)`,
              }"
            ></div>
            <div class="graphPopup">
              <div class="graphPopupNum">{{ userCount }}</div>
              <div class="graphPopupDate">{{ listOfDays[index] }}</div>
            </div>
          </div>
        </div>

        <div class="analyticsBoldFont" style="margin-top: 20px">
          Weekly breakdown
        </div>
        <div
          v-if="!showingMore"
          class="refreshButton canRefresh"
          @click="showMore()"
        >
          Show more
        </div>
        <div v-else>
          <div
            v-for="(uniRow, index) in newUserBreakdown"
            :key="index"
            class="uniRow"
          >
            <div
              v-for="(dayInfo, index) in uniRow"
              :key="index"
              class="dayInfo"
            >
              {{ dayInfo }}
            </div>
          </div>
        </div>
      </div>
      <p class="boldTitle leftAligned">Daily Messages</p>
      <div class="whiteStatBox">
        <div class="analyticsBoldFont">Showing results for</div>
        <div class="analyticsBigFont">
          <!--@click="openJoinedPerUni('joined')"-->
          {{ currentPicked }}
          <img height="20" width="20" src="../assets/analyticsDropown.svg" />
        </div>

        <div class="graph">
          <div
            class="graphItem"
            v-for="(messages, index) in DailyMessages"
            :key="index"
          >
            <div
              class="analyticsGraphLine"
              :style="{
                'max-height': `calc(${(messages / maxDailyMessages) * 100}%)`,
              }"
            ></div>
            <div class="graphPopup">
              <div class="graphPopupNum">{{ messages }}</div>
              <div class="graphPopupDate">{{ listOfDays[index] }}</div>
            </div>
          </div>
        </div>

        <!--div class="analyticsBoldFont" style="margin-top: 20px">
          Weekly breakdown
        </div>
        <div
          v-for="(uniRow, index) in messagesBreakdown"
          :key="index"
          class="uniRow"
        >
          <div v-for="(dayInfo, index) in uniRow" :key="index" class="dayInfo">
            {{ dayInfo }}
          </div>
        </div-->
      </div>
      <p class="boldTitle leftAligned">Daily Groups Joined</p>
      <div class="whiteStatBox">
        <div class="analyticsBoldFont">Showing results for</div>
        <div class="analyticsBigFont">
          <!--@click="openJoinedPerUni('joined')"-->
          {{ currentPicked }}
          <img height="20" width="20" src="../assets/analyticsDropown.svg" />
        </div>

        <div class="graph">
          <div
            class="graphItem"
            v-for="(groupJoined, index) in DailyGroupsJoined"
            :key="index"
          >
            <div
              class="analyticsGraphLine"
              :style="{
                'max-height': `calc(${(groupJoined / maxDailyGroupsJoined) *
                  100}%)`,
              }"
            ></div>
            <div class="graphPopup">
              <div class="graphPopupNum">{{ groupJoined }}</div>
              <div class="graphPopupDate">{{ listOfDays[index] }}</div>
            </div>
          </div>
        </div>

        <!--div class="analyticsBoldFont" style="margin-top: 20px">
          Weekly breakdown
        </div>
        <div
          v-for="(uniRow, index) in joinGroupBreakdown"
          :key="index"
          class="uniRow"
        >
          <div v-for="(dayInfo, index) in uniRow" :key="index" class="dayInfo">
            {{ dayInfo }}
          </div>
        </div-->
      </div>
    </div>
  </section>
</template>

<script>
import Navbar from "@/components/Navbar";
import db from "@/db";

export default {
  components: {
    Navbar,
  },
  data: () => ({
    canUpdate: false,
    showingMore: false,
    countFrom: 1630987200000, //7th of September
    timeNow: Date.now(),
    userJoinedPerDay: [],
    maxUserJoinedPerDay: 1,
    DailyMessages: [],
    maxDailyMessages: 1,
    DailyGroupsJoined: [],
    maxDailyGroupsJoined: 1,
    weekMax: 2,
    listOfDays: [],
    onJoinedUniList: false,
    currentPicked: "All Universities",
    listOfUnis: [
      "All Universities",
      "University of Guelph",
      "University of Calgary",
      "McGill University",
      "University of Waterloo",
      "University of Toronto",
      "Ryerson University",
      "Carleton University",
      "University of Illinois",
      "University of Saskatchewan",
      "University of Chicago",
      "University of British Columbia",
      "Wilfrid Laurier University",
      "Dalhousie University",
      "Northwestern University",
      "Brock University",
      "Kwantlen Polytechnic University",
      "University of Alberta",
      "Mount Royal University",
      "University of Manitoba",
      "University of Victoria",
      "Ontario Tech University",
      "Trent University",
      "Queen's University",
      "University of Ottawa",
      "MacEwan University",
      "University of Windsor",
      "Loyola University Chicago",
      "Memorial University of Newfoundland",
      "Simon Fraser University",
      "Test University",
      "Western University",
      "DePaul University",
      "University of Regina",
      "Thompson Rivers University",
      "Concordia University",
      "University of Lethbridge",
      "York University",
      "McMaster University",
    ],
    newUserBreakdown: [
      ["University", "", "", "", "", "", "", "", "Total"],
      ["Total", 0, 0, 0, 0, 0, 0, 0, 0],
      ["Mcgill", 0, 0, 0, 0, 0, 0, 0, 0],
      ["Western", 0, 0, 0, 0, 0, 0, 0, 0],
      ["Guelph", 0, 0, 0, 0, 0, 0, 0, 0],
      ["Queen's", 0, 0, 0, 0, 0, 0, 0, 0],
      ["UofT", 0, 0, 0, 0, 0, 0, 0, 0],
      ["UOttawa", 0, 0, 0, 0, 0, 0, 0, 0],
      ["Ryerson", 0, 0, 0, 0, 0, 0, 0, 0],
      ["UBC", 0, 0, 0, 0, 0, 0, 0, 0],
      ["McMaster", 0, 0, 0, 0, 0, 0, 0, 0],
      ["Other", 0, 0, 0, 0, 0, 0, 0, 0],
    ],
    messagesBreakdown: [
      ["University", "", "", "", "", "", "", "", "Total"],
      ["Total", 0, 0, 0, 0, 0, 0, 0, 0],
      ["Mcgill", 0, 0, 0, 0, 0, 0, 0, 0],
      ["Western", 0, 0, 0, 0, 0, 0, 0, 0],
      ["Guelph", 0, 0, 0, 0, 0, 0, 0, 0],
      ["Queen's", 0, 0, 0, 0, 0, 0, 0, 0],
      ["UofT", 0, 0, 0, 0, 0, 0, 0, 0],
      ["UOttawa", 0, 0, 0, 0, 0, 0, 0, 0],
      ["Ryerson", 0, 0, 0, 0, 0, 0, 0, 0],
      ["UBC", 0, 0, 0, 0, 0, 0, 0, 0],
      ["McMaster", 0, 0, 0, 0, 0, 0, 0, 0],
      ["Other", 0, 0, 0, 0, 0, 0, 0, 0],
    ],
    joinGroupBreakdown: [
      ["University", "", "", "", "", "", "", "", "Total"],
      ["Total", 0, 0, 0, 0, 0, 0, 0, 0],
      ["Mcgill", 0, 0, 0, 0, 0, 0, 0, 0],
      ["Western", 0, 0, 0, 0, 0, 0, 0, 0],
      ["Guelph", 0, 0, 0, 0, 0, 0, 0, 0],
      ["Queen's", 0, 0, 0, 0, 0, 0, 0, 0],
      ["UofT", 0, 0, 0, 0, 0, 0, 0, 0],
      ["UOttawa", 0, 0, 0, 0, 0, 0, 0, 0],
      ["Ryerson", 0, 0, 0, 0, 0, 0, 0, 0],
      ["UBC", 0, 0, 0, 0, 0, 0, 0, 0],
      ["McMaster", 0, 0, 0, 0, 0, 0, 0, 0],
      ["Other", 0, 0, 0, 0, 0, 0, 0, 0],
    ],
  }),
  mounted() {
    //this.findNewUsers();
    //this.findMessages();
    this.getFromDatabase();
    this.findDays();
  },
  computed: {},
  methods: {
    getFromDatabase() {
      db.collection("analytics")
        .doc("f5vVVlGBEddX4W0Xpsm5")
        .get()
        .then((doc) => {
          if (doc.data().lastUpdated < this.timeNow - 86400000) {
            this.canUpdate = true;
          }
          this.userJoinedPerDay = doc.data().userJoinedPerDay;
          this.DailyMessages = doc.data().DailyMessages;
          this.DailyGroupsJoined = doc.data().DailyGroupsJoined;
          this.maxUserJoinedPerDay = Math.max(...doc.data().userJoinedPerDay);
          this.maxDailyMessages = Math.max(...doc.data().DailyMessages);
          this.maxDailyGroupsJoined = Math.max(...doc.data().DailyGroupsJoined);
          console.log(this.maxUserJoinedPerDay);
        });
    },
    async refreshPage() {
      if (this.canUpdate) {
        this.userJoinedPerDay = [];
        this.DailyMessages = [];
        this.DailyGroupsJoined = [];
        this.canUpdate = false;
        await this.findNewUsers();
        await this.findMessages();
        var tempMap = new Map();
        this.newUserBreakdown.forEach((arr) => {
          var title = arr[0];
          tempMap.set(title, arr.slice(1, 9));
          //console.log(title);
        });
        console.log(tempMap);
        db.collection("analytics")
          .doc("f5vVVlGBEddX4W0Xpsm5")
          .set({
            DailyGroupsJoined: this.DailyGroupsJoined,
            userJoinedPerDay: this.userJoinedPerDay,
            DailyMessages: this.DailyMessages,
            lastUpdated: this.timeNow,
          });
      }
    },
    async showMore() {
      this.showingMore = true;
      this.userJoinedPerDay = [];
      await this.findNewUsers();
    },
    async findNewUsers() {
      var loopedAmount = 1;
      var numPerDay = 0;
      var dayOfWeek = 0;
      var lastMidnight = new Date();
      lastMidnight.setHours(0, 0, 0, 0); // last midnight
      await db
        .collection("users")
        .where("created_at", ">=", 1630990800000)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            var timeCreation = doc.data().created_at;
            if (timeCreation <= this.countFrom + loopedAmount * 86400000) {
              numPerDay++;
              if (timeCreation > lastMidnight - 604800000 && dayOfWeek != 0) {
                this.joinedWeeklyBreakdown(
                  this.newUserBreakdown,
                  doc.data(),
                  dayOfWeek
                );
              }
            } else {
              this.userJoinedPerDay.push(numPerDay);
              if (numPerDay > this.maxUserJoinedPerDay) {
                this.maxUserJoinedPerDay = numPerDay;
              }
              numPerDay = 1;
              loopedAmount++;
              if (timeCreation > lastMidnight - 604800000) {
                dayOfWeek++;
                this.joinedWeeklyBreakdown(
                  this.newUserBreakdown,
                  doc.data(),
                  dayOfWeek
                );
              }
            }
          });
        });
    },
    joinedWeeklyBreakdown(listToAdd, userInfo, dayOfWeek) {
      listToAdd[1][dayOfWeek]++;
      listToAdd[1][8]++;
      switch (userInfo.school_id) {
        case "5Uo24jSg4nGg3sVOzeec":
          listToAdd[2][dayOfWeek]++;
          listToAdd[2][8]++;
          break;
        case "pOFdIKe2KVcQ8IbEl6sw":
          listToAdd[3][dayOfWeek]++;
          listToAdd[3][8]++;
          break;
        case "1lv8EkSNVu0XRWbV5bfJ":
          listToAdd[4][dayOfWeek]++;
          listToAdd[4][8]++;
          break;
        case "ZYEtBmUsC1gxEgCXcqrO":
          listToAdd[5][dayOfWeek]++;
          listToAdd[5][8]++;
          break;
        case "6StICCPUC4vEQD8LzAto":
          listToAdd[6][dayOfWeek]++;
          listToAdd[6][8]++;
          break;
        case "dWQpMtihliZhnC8BhEvk":
          listToAdd[7][dayOfWeek]++;
          listToAdd[7][8]++;
          break;
        case "6YhBHH63lQgkiqbdhlhV":
          listToAdd[8][dayOfWeek]++;
          listToAdd[8][8]++;
          break;
        case "Lk6U5xlHtZEeKvJhfGmD":
          listToAdd[9][dayOfWeek]++;
          listToAdd[9][8]++;
          break;
        case "ynN6QCUHtxgptPBDq7tQ":
          listToAdd[10][dayOfWeek]++;
          listToAdd[10][8]++;
          break;
        default:
          listToAdd[11][dayOfWeek]++;
          listToAdd[11][8]++;
          break;
      }
    },
    findNewUsersPerUni(uniName) {
      var loopedAmount = 1;
      var numPerDay = 0;
      db.collection("users")
        .where("created_at", ">=", 1630990800000)
        .where("school_id", "==", uniName)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            var timeCreation = doc.data().created_at;
            if (timeCreation <= this.countFrom + loopedAmount * 86400000) {
              numPerDay++;
            } else {
              this.userJoinedPerDay.push(numPerDay);
              if (numPerDay > this.maxUserJoinedPerDay) {
                this.maxUserJoinedPerDay = numPerDay;
              }
              numPerDay = 1;
              loopedAmount++;
            }
          });
        });
    },
    async findMessages() {
      var loopedAmount = 1;
      var numJoinedPerDay = 0;
      var numChatPerDay = 0;
      //var dayOfWeek = 0;
      //var lastMidnight = new Date();
      //lastMidnight.setHours(0, 0, 0, 0); // last midnight
      await db
        .collection("posts")
        .where("created_at", ">=", 1630990800000)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            var timeCreation = doc.data().created_at;
            if (timeCreation <= this.countFrom + loopedAmount * 86400000) {
              if (doc.data().user_id) {
                numChatPerDay++;
              } else {
                numJoinedPerDay++;
              }
            } else {
              this.DailyGroupsJoined.push(numJoinedPerDay);
              this.DailyMessages.push(numChatPerDay);
              if (numChatPerDay > this.maxDailyMessages) {
                this.maxDailyMessages = numChatPerDay;
              }
              if (numJoinedPerDay > this.maxDailyGroupsJoined) {
                this.maxDailyGroupsJoined = numJoinedPerDay;
              }
              if (doc.data().user_id) {
                numChatPerDay = 1;
                numJoinedPerDay = 0;
              } else {
                numJoinedPerDay = 1;
                numChatPerDay = 1;
              }
              loopedAmount++;
            }
          });
        });
    },
    findDays() {
      var currentDay = 1630990800000;
      var i = 0;
      while (currentDay < this.timeNow) {
        var tempDate = new Date(currentDay);
        currentDay += 24 * 60 * 60 * 1000;
        this.listOfDays.push(tempDate.toString().slice(0, 10));

        var lastMidnight = new Date();
        lastMidnight.setHours(0, 0, 0, 0); // last midnight
        if (currentDay > lastMidnight - 604800000) {
          if (i > 0 && i < 8) {
            this.newUserBreakdown[0][i] = tempDate.toString().slice(0, 10);
          }
          i++;
        }
      }
    },
    openJoinedPerUni(name) {
      if (name == "joined") {
        this.onJoinedUniList = !this.onJoinedUniList;
      }
    },
    pickJoinedUni(pickedUni) {
      this.userJoinedPerDay = [];
      if (
        pickedUni == "All Universities" &&
        this.currentPicked != "All Universitis"
      ) {
        this.findNewUsers();
      } else if (this.currentPicked != pickedUni) {
        db.collection("schools")
          .where("name", "==", pickedUni)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              this.findNewUsersPerUni(doc.data().id);
            });
          });
      }
      this.currentPicked = pickedUni;
    },
  },
};
</script>

<style src="@/styles/views/Analytics.css"></style>
